<div class="container">
  <div class="expandCollapse" [ngStyle]="{'text-align': buttonName === 'Collapse All'? 'right' : 'right' }">
    <a class="expand" (click)="toggle($event)">{{buttonName}}</a>
  </div>

  <div class="expandCollapseContent" *ngIf="!showRuleContent">
    <div *ngFor="let data of modelNotifications; let j = index">
      <div class="asset-panel" fxLayout="row" [hidden]="hideme[j]">
        <div fxFlex="column" fxFlex="10">
          <div fxFlex="row">
            <div class="empty-space"></div>
          </div>
        </div>
        <div fxFlex="column" fxFlex="90">
          <div fxLayout="row">
            <div class="content" fxFlex="column" fxFlex="70">Failure #&nbsp;{{data.faultCode}}</div>
            <div class="buttons" fxFlex="column" fxFlex="30">
              <button class="status-btn"
                [ngStyle]="{'background-color':data.statusName === 'INPROGRESS' ? '#E4B720' : ' #E35100' }">
                {{ (data.statusName === 'INPROGRESS') ? 'In Progress' : 'Open' }}
              </button>
            </div>
          </div>
          <div class="heading"> Equipement:&nbsp;<strong>{{data.eqName}}</strong> </div>
          <div class="heading"> Suffix:&nbsp;<strong>{{data.suffixName}}</strong></div>
          <div class="heading"> ELR:&nbsp;<strong>{{data.Elr}}</strong> </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showRuleContent" class="count" (click)="toggle($event)">
    <p class="defect-count">
      <span class="badge badge-pill badge-danger">{{count}}</span>
    </p>
  </div>
</div>